import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';


import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';

/**
 * Food data with nested structure.
 * Each node has a name and an optional list of children.
 */
interface FoodNode {
  name: string;
  children?: FoodNode[];
}

const TREE_DATA: FoodNode[] = [
  {
    name: 'Core',
    children: [
      {name: 'Admission',
      children:[
        {name: 'HR & Training'},
        {name: 'Real Estate'},
      ]
      },
      
    ]
  }, {
    name: 'Task',
    children: [
      {
        name: 'Process Intelligence',
        children: [
          {name: 'AI'},
          {name: 'VR'},
        ]
      }, {
        name: 'UI',
        children: [
          {name: 'Front End',
          children: [
            {name: 'Landing',
              children: [
                {name: 'Website',
                children:[
                  {name: 'Sports',
                  children:[
                    {name: 'Cricket'},
                    {name: 'Tennis'},
                  ]
                  },
                  {name: 'Business'},
                ]
                },
                {name: 'Marketing'},
              ]
            },
            {name: 'Broucher'},
          ]
         },
          {name: 'Backend'},
        ]
      },
    ]
  },
];

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}
/**
 * @title Tree with flat nodes
 */

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string,
}

@Component({
  selector: 'app-intelligence-dashboard',
  templateUrl: './intelligence-dashboard.component.html',
  styleUrls: ['./intelligence-dashboard.component.scss']
})
export class IntelligenceDashboardComponent implements OnInit {

  docDetail:boolean = false;
  showmyDrive:boolean = false;
  addNote:boolean = false;


  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(
      node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.children);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);


  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;




  constructor(private dialog: MatDialog,) {
    this.dataSource.data = TREE_DATA;

    this.filteredStates = this.stateCtrl.valueChanges
    .pipe(
      startWith(''),
      map(state => state ? this._filterStates(state) : this.states.slice())
    );

   }

   private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();

    return this.states.filter(state => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

    stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;

  states: State[] = [
    {
      name: 'Abbott',
      email: 'Abbott@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/Abbott.jpg'
    },
    {
      name: 'Alice',
      email: 'alice.@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/alice.jpg'
    },
    {
      name: 'Carl',
      email: 'carl@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/carl.jpg'
    },
    {
      name: 'Jane',
      email: 'jane@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/jane.jpg'
    },
    {
      name: 'Tillman',
      email: 'tillman.@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/Tillman.jpg'
    },
    {
      name: 'Josefina',
      email: 'Josefina@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/Josefina.jpg'
    },
    {
      name: 'Create New',
      email: ' ',
      role: ' ',
      pic: ' '
    },

  ];


  showDocDetail(){
    this.docDetail = !this.docDetail
  }
  showMyDrive(){
    this.showmyDrive = !this.showmyDrive
  }
  addNewNote(){
    this.addNote = !this.addNote
  }


 


  addFolder(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef,{
      panelClass: 'custom-modalbox'
    });

  }


  close() {
    this.dialog.closeAll();
  }

  createFolders(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef,{
      //panelClass: 'custom-modalbox'
    })
  }



  ngOnInit(): void {
  }

  peoples =[
    {
      name : 'Katina',
      email: 'Katina@gmail.com',
      img: 'Katina.jpg',       
    },
    {
      name : 'joyce',
      email: 'joyce@gmail.com',
      img: 'joyce.jpg',       
    },
    {
      name : 'Christy',
      email: 'Christy@gmail.com',
      img: 'Christy.jpg',       
    },
    {
      name : 'garry',
      email: 'garry@gmail.com',
      img: 'garry.jpg',       
    },
    {
      name : 'Barrera',
      email: 'Barrera@gmail.com',
      img: 'Barrera.jpg',       
    },
    
    
  ]

}
